// src/utils/validators.js
export const validateVIN = (vin) => {
    if (!vin) return { valid: false, message: 'VIN jest wymagany.' }
    
    const cleanVin = vin.trim().toUpperCase()
    
    if (cleanVin.length !== 17) {
        return { valid: false, message: 'Numer VIN musi składać się dokładnie z 17 znaków.' }
    }
    
    if (/[IOQ]/.test(cleanVin)) {
        return { valid: false, message: 'Numer VIN nie może zawierać liter I, O oraz Q.' }
    }
    
    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(cleanVin)) {
        return { valid: false, message: 'Numer VIN zawiera niedozwolone znaki.' }
    }

    const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2]
    const values = {
        A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8,
        J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9,
        S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9
    }

    let sum = 0
    for (let i = 0; i < 17; i++) {
        const char = cleanVin[i]
        const val = /\d/.test(char) ? parseInt(char, 10) : values[char]
        if (val === undefined) return { valid: false, message: 'Nieprawidłowy znak w numerze VIN.' }
        sum += val * weights[i]
    }

    const remainder = sum % 11
    const checkDigit = remainder === 10 ? 'X' : remainder.toString()
    
    if (cleanVin[8] !== checkDigit) {
        return { valid: true, warning: 'Suma kontrolna VIN budzi wątpliwości (sprawdź poprawność).' }
    }

    return { valid: true, message: 'VIN poprawny.' }
}

export const validatePESEL = (pesel) => {
    if (!pesel) return { valid: false, message: 'Numer PESEL jest wymagany.' }
    
    const cleanPesel = pesel.trim()
    
    // 1. Sprawdzenie długości (dokładnie 11 cyfr)
    if (!/^\d{11}$/.test(cleanPesel)) {
        return { valid: false, message: 'Numer PESEL musi składać się dokładnie z 11 cyfr.' }
    }
    
    // 2. Parsowanie daty z numeru PESEL
    let year = parseInt(cleanPesel.substring(0, 2), 10)
    let month = parseInt(cleanPesel.substring(2, 4), 10)
    const day = parseInt(cleanPesel.substring(4, 6), 10)
    
    // Określenie stulecia i korekta miesiąca
    if (month > 80 && month <= 92) {
        year += 1800
        month -= 80
    } else if (month > 0 && month <= 12) {
        year += 1900
    } else if (month > 20 && month <= 32) {
        year += 2000
        month -= 20
    } else if (month > 40 && month <= 52) {
        year += 2100
        month -= 40
    } else if (month > 60 && month <= 72) {
        year += 2200
        month -= 60
    } else {
        return { valid: false, message: 'Nieprawidłowy miesiąc w numerze PESEL.' }
    }
    
    // Sprawdzenie poprawności daty urodzenia
    const birthDate = new Date(year, month - 1, day)
    if (
        birthDate.getFullYear() !== year ||
        birthDate.getMonth() !== month - 1 ||
        birthDate.getDate() !== day
    ) {
        return { valid: false, message: 'Numer PESEL zawiera niepoprawną datę urodzenia.' }
    }
    
    // 3. Algorytm sumy kontrolnej
    const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3]
    let sum = 0
    for (let i = 0; i < 10; i++) {
        sum += parseInt(cleanPesel[i], 10) * weights[i]
    }
    
    let checksum = 10 - (sum % 10)
    if (checksum === 10) checksum = 0
    
    if (checksum !== parseInt(cleanPesel[10], 10)) {
        return { valid: false, message: 'Nieprawidłowa suma kontrolna numeru PESEL.' }
    }

    return { valid: true, message: 'PESEL poprawny.' }
}

